module.exports = __webpack_public_path__ + "img/stakebody_stopped.8be048f6.svg";